import axios, { AxiosResponse } from 'axios';
import { IPersonalBeca, PersonalBeca } from '@/shared/model/seguimiento/personal-beca.model';
import { Area } from '@/shared/model/enumerations/area';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';
import buildQueryOpts from '@/shared/filter/filtering';

const baseApiUrl = 'api/personalBecas/cvuSessionArea';

export default class PersonalBecaService {
  public find(incluirClaves: boolean, area: Area): Promise<IPersonalBeca> {
    return new Promise<IPersonalBeca>((resolve, reject) => {
      axios
        .get(baseApiUrl, { params: { incluirClaves, area } })
        .then(res => {
          resolve(PersonalBeca.fromObject(res.data));
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findRolesByArea(area: Area): Promise<AxiosResponse<Array<IPersonalBeca>>> {
    return new Promise<AxiosResponse<Array<IPersonalBeca>>>((resolve, reject) => {
      axios
        .get(`api/personalBecas/rolesByArea?area=${area}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public findByClaveInstitucionRoles(
    claveInstitucion: string,
    rolesAutoridad: Array<RolAutoridad>,
    area: Area
  ): Promise<Array<IPersonalBeca>> {
    return new Promise<Array<IPersonalBeca>>((resolve, reject) => {
      const params = new URLSearchParams();
      params.append('area', area);
      rolesAutoridad.forEach(rol => params.append('rolesAutoridad', rol));
      axios
        .get(`api/personalBecas/institucion/${claveInstitucion}/roles`, { params })
        .then(res => {
          const extraidos = [];
          (res.data ?? []).forEach(element => {
            extraidos.push(PersonalBeca.fromObject(element));
          });
          resolve(extraidos);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public asociarInstitucion(claveInstitucion: string, personalBecas: PersonalBeca): Promise<IPersonalBeca> {
    return new Promise<IPersonalBeca>((resolve, reject) => {
      axios
        .post(`api/personalBecas/institucion/${claveInstitucion}/asociar`, personalBecas)
        .then(res => {
          resolve(PersonalBeca.fromObject(res.data));
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public desasociarInstitucion(claveInstitucion: string, personalBecas: PersonalBeca): Promise<IPersonalBeca> {
    return new Promise<IPersonalBeca>((resolve, reject) => {
      axios
        .patch(`api/personalBecas/institucion/${claveInstitucion}/desasociar`, personalBecas)
        .then(res => {
          resolve(PersonalBeca.fromObject(res.data));
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public obtenerPersonalBecas(filtro?: any): Promise<AxiosResponse<Array<IPersonalBeca>>> {
    return new Promise<AxiosResponse<Array<IPersonalBeca>>>((resolve, reject) => {
      axios
        .get(`api/personalBecas?${buildQueryOpts(filtro)}`)
        .then(res => {
          if (res?.data?.length > 0) {
            const personalBecas = res.data.map(personalBeca => PersonalBeca.fromObject(personalBeca));
            res.data = personalBecas;
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public obtenerPersonalBecasPorInstitucinYRoles(
    claveInstitucion: string,
    rolesAutoridad: Array<RolAutoridad>
  ): Promise<AxiosResponse<Array<IPersonalBeca>>> {
    return new Promise<AxiosResponse<Array<IPersonalBeca>>>((resolve, reject) => {
      const params = new URLSearchParams();
      rolesAutoridad.forEach(rol => params.append('roles', rol));
      axios
        .get(`api/personalBecas/posgrado?clavesInstitucion=${claveInstitucion}&${params.toString()}`)
        .then(res => {
          if (res?.data?.length > 0) {
            const personalBecas = res.data.map((personalBeca: IPersonalBeca) => PersonalBeca.fromObject(personalBeca));
            res.data = personalBecas;
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public registrarClavecomisionAPersonalBecas(personal: PersonalBeca): Promise<PersonalBeca> {
    return new Promise<PersonalBeca>((resolve, reject) => {
      axios
        .post('api/personalBecas', personal)
        .then(res => resolve(PersonalBeca.fromObject(res?.data ?? {})))
        .catch(err => reject(err));
    });
  }

  public eliminarClaveComisionDePersonalBecas(personal: PersonalBeca): Promise<PersonalBeca> {
    return new Promise<PersonalBeca>((resolve, reject) => {
      axios
        .delete('api/personalBecas', { data: personal })
        .then(res => resolve(PersonalBeca.fromObject(res?.data ?? {})))
        .catch(err => reject(err));
    });
  }

  public desasignarClavesComisionDeConvocaroria(area: Area, rol: RolAutoridad, solucionId: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      axios
        .put(`api/personalBecas/desasignarClavesComision/${area}/${rol}/${solucionId}`)
        .then(() => resolve())
        .catch(err => reject(err));
    });
  }
}
